// extracted by mini-css-extract-plugin
export var a8 = "sidebar-module--a8--39e11";
export var drawerNav = "sidebar-module--drawerNav--f857b";
export var drawerNav__item = "sidebar-module--drawerNav__item--000c8";
export var menu = "sidebar-module--menu--3f004";
export var sidebar = "sidebar-module--sidebar--25bea";
export var widgetMap = "sidebar-module--widgetMap--35e34";
export var widgetMap__img = "sidebar-module--widgetMap__img--23abd";
export var widget__item_body = "sidebar-module--widget__item_body--8aa5f";
export var widget__title = "sidebar-module--widget__title--c174a";
export var widget_archive = "sidebar-module--widget_archive--561d4";
export var widget_nav_menu = "sidebar-module--widget_nav_menu--ac53e";